module.exports = __webpack_public_path__ + "static/img/blue.0d9842f9.png";